import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import WasapayLogo from "../../assets/img/btransfer-logo.svg";
import AllowedCards from "../../assets/img/allowed-cards.svg";
import { usePayDataContext } from "../../contexts/PayDataContext";
import { useNavigate } from "react-router-dom";
import "./checkout.scss";

const App = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const { merchantData, businessName, setCustomerInfo } = usePayDataContext();

  const paymentLinkReference = pathname.split("/").pop();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    fullName: "",
    emailError: "",
    fullNameError: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (formData.fullName && formData.email) {
      navigate(`/pay/${paymentLinkReference}`);

      setCustomerInfo({
        fullName: formData.fullName,
        email: formData.email,
      });
    }
  };

  return (
    <Fragment>
      {!merchantData ? (
        <div className="flex flex-col justify-center items-center h-screen">
          <svg
            className={`animate-spin mr-1 w-16 mt-px text-[var(--SarepayPrimary-color)]`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          <p className="text-primary font-medium pt-2 text-sm">
            Please wait...
          </p>
        </div>
      ) : (
        <div className="Inter-Regular py-4">
            <div className="bg-white border border-[#e4e7ec] w-full md:w-[480px] rounded-2xl p-10 mx-auto shadow-xl shadow-[#6366f122]">
            <div className="flex justify-center">
              <img src={WasapayLogo} alt="BT Payment Logo" className="h-10 w-auto object-contain" />
            </div>
            <div className="pt-14 text-center">
              <h1 className="text-2xl md:text-3xl text-[var(--SarepayPrimary-color)] Inter-Semibold">
                {businessName}
              </h1>
              <p className="uppercase text-sm py-6">
                by <span className="text-[var(--SarepayPrimary-color)]">BT Payment</span>
              </p>
              <p className="uppercase text-sm">
                Payment for{" "}
                <span className="text-[var(--SarepayPrimary-color)] Inter-Semibold">
                  {merchantData?.title}
                </span>
              </p>
              <p className="text-sm">({merchantData?.meta.description})</p>
            </div>

            <form onSubmit={handleSubmit} className="pt-7">
              <div>
                <label className="text-secondary font-semibold text-[14px]/[13px] tracking-tight">
                  <div>
                    <span className="text-sm inline-block pb-2">Full Name</span>
                  </div>

                  <div>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      placeholder="e.g. Jessica Michael"
                      onChange={handleInputChange}
                      value={formData.fullName}
                      className={`w-full text-gray-600 px-3 py-3 border rounded-md focus:outline-none ${
                        formData.fullNameError
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                    />
                  </div>
                </label>
                <div>
                  <span className="text-sm text-red-500">
                    {formData.fullNameError && formData.fullNameError}
                  </span>
                </div>
              </div>

              <div className="py-6">
                <label className="text-secondary font-semibold text-[14px]/[13px] tracking-tight">
                  <div>
                    <span className="text-sm inline-block pb-2">
                      Email Address
                    </span>
                  </div>

                  <div>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="e.g. you@example.com"
                      onChange={handleInputChange}
                      value={formData.email}
                      className={`w-full text-gray-600 px-3 py-3 border rounded-md focus:outline-none ${
                        formData.emailError
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                    />
                  </div>
                </label>
                <div>
                  <span className="text-sm text-red-500">
                    {formData.emailError}
                  </span>
                </div>
              </div>

              <button
                type="submit"
                className="w-full text-white rounded-xl py-3.5 mt-5 text-sm disabled:cursor-not-allowed font-semibold hover:opacity-90 transition-all"
                style={{
                  background:
                    "linear-gradient(135deg, var(--SarepayPrimary-color) 0%, var(--Checkout-accent-color) 100%)",
                }}
                disabled={!formData.email && !formData.fullName}
              >
                Continue
              </button>
            </form>

            <hr className="mt-12" />

            <div className="flex flex-col items-center mt-7">
              <div className="flex items-center border rounded-md border-[#727272] px-5 py-2 mb-5">
                <span className="text-sm">Secured by</span>&nbsp;
                <img src={WasapayLogo} width="89" height="18" alt="BT Payment Logo" />
              </div>
              <img src={AllowedCards} alt="Allowed Card Types" />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default App;
